import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { FormControl, Select, MenuItem, Grid, Link, InputLabel } from '@mui/material';
import { css } from '@emotion/react';
import {
  Paper,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Container,
  Snackbar
} from '@mui/material';
import Page from '../components/Page';

import UserService from '../services/user_service'

const useStyles = styled((theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
}));


const styles = {
  formControl: css`
    margin-bottom: 16px;
    padding: 8px;
  `,
  inputLabel: css`
    margin-bottom: 8px;
    padding-left: 8px;
  `,
  select: css`
    margin-top: 8px;
  `,
  menuItem: css`
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
    &.Mui-selected {
      background-color: rgba(0, 0, 0, 0.08);
    }
  `,
};


function SettingsPage() {
  const classes = useStyles();
  const [language, setLanguage] = useState('en');
  const [isLoading, setIsLoading] = useState(true);
  const [errorText, setErrorText] = useState('');
  const [errorShow, setErrorShow] = useState(false);

  const handleChange = event => {
    var beforeLang = language;
    setLanguage(event.target.value);
    UserService.changeUserSettings(event.target.value)
      .then(response => {
        setLanguage(response.data['translation_lang'])
      })
      .catch(error => {
        setLanguage(beforeLang);
        setErrorText(error.message)
        setErrorShow(true);
      })
  };

  function loadSettings() {
    UserService.getUserSettings()
      .then((response) => response.data)
      .then((data) => setLanguage(data['translation_lang']))
      .then((data) => setIsLoading(false))
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    // if (isLoading) {
    loadSettings();
    // }
  }, []);



  return (
    <Page title="Settings">
      <Container >
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={errorShow}
          message={errorText}
        />
        <Typography variant="h4" className={classes.title}>
          Settings
        </Typography>
        <FormControl sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography spacing={3} marginTop={2} marginRight={3}>Translation language</Typography>
          <Select value={language} onChange={handleChange}>
            <MenuItem value={"en"}>English</MenuItem>
            <MenuItem value={"fr"}>Français</MenuItem>
            <MenuItem value={"ru"}>Русский</MenuItem>
          </Select>
        </FormControl>


      </Container>
    </Page>
  );
}

export default SettingsPage;